// redirection here after login is complete

import "../App.css";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// import axios from "axios";

import { AppsContext } from "../context/AppsContext.tsx";
import { ColorModeIcon, DarkModeContext } from "../context/ColorModeContext.tsx";

import "../CSS/programmes/ProgramOverview.css";
import { appNameMapping } from "../CommonVariables.tsx";

import Navbar from "../components/Navbar.tsx";

import { useCurrentApp } from "../context/CurrentAppContext.tsx";

// import { App } from "./main";

// import data from "../public/example_backend_files/example_programs.json";

// redirection here after login in

const isAppName = (key: string): key is keyof typeof appNameMapping => {
  return key in appNameMapping;
};
const ProgramOverview: React.FC = () => {
  const backendUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL;

  const navigate = useNavigate();
  const context = useContext(AppsContext);
  if (!context) {
    throw new Error("Navbar must be used within an AppsProvider");
  }
  const { apps } = context;
  const { setCurrentApp } = useCurrentApp();
  const darkModeContext = useContext(DarkModeContext);
  const { darkMode } = darkModeContext;

  // Manages routing to the clicked program
  // Currently alert for not implemented programs
  const gotoProgram = (programName: string) => {
    setCurrentApp(programName); // from CurrentAppContext

    if (programName === "OnlineOffline_Artikel") {
      // isAuthenticated(token);
      navigate("/OnOffArticle");
    } else if (programName === "OnlineOffline_Liste") {
      // isAuthenticated(token);
      navigate("/OnOffList");
    } else if (programName === "ItemPricing") {
      navigate("/ItemPricing");
    } else if (programName === "OrderProcessing") {
      navigate("/OrderProcessing");
    } else if (programName === "LabelPrinter") {
      navigate("/LabelPrinter");
    } else if (programName === "ItemCreator") {
      navigate("/ItemCreator");
    } else if (programName === "AdminPanel") {
      navigate("/AdminPanel");
    } else if (programName === "ListingCreator") {
      navigate("/ListingCreator");
    } else if (programName === "StatisticsAnalyzer") {
      navigate("/StatisticsAnalyzer");
    } else if (programName === "DataChecker") {
      navigate("/DataChecker");
    }
    else {
      alert("Redirecting to " + programName);
    }
  };

  // create boxes with the program names in it

  //const availableProgs = getPrograms(data); // later uses list of programs which is received from backend
  // useEffect(() => {
  //   // This function fetches all the images asynchronously
  //   const fetchImages = async () => {
  //     try {
  //       const mode = darkMode ? "dark" : "bright";
  //       const requests = apps.map((app) =>
  //         axios.get(`http://localhost:8000${app.image_url}${mode}`, {
  //           headers: {
  //             "Access-Control-Allow-Origin": "*",
  //             // Add other headers if needed
  //           },
  //         })
  //       );
  //       await Promise.all(requests);
  //     } catch (error) {
  //       console.error("Error loading images:", error);
  //     }
  //   };
  //
  //   fetchImages();
  // }, [apps, darkMode]);

  const renderProgList = () => {
    return (
      <div className="apps-list-container">
        <h1>Programmübersicht</h1>
        <div className="apps-list">
          {apps
            // Sort alphabetically
            .sort((a, b) => {
              const nameA = appNameMapping[a.application] || a.application;
              const nameB = appNameMapping[b.application] || b.application;
              return nameA.localeCompare(nameB);
            })
            .map((app, index) => (
            <div
              key={index}
              className="apps-item"
              onClick={() => gotoProgram(app.application)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={`${backendUrl}${app.image_url}_${darkMode ? "dark" : "bright"}.png`}
                alt={app.application}
              />
              <div className="text-content">
                <h2>
                  {isAppName(app.application)
                    ? appNameMapping[app.application]
                    : "appNameMapping nicht verfügbar für " + app.application}
                </h2>
                <p>{app.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>{"Program Overview"}</title>
      </Helmet>
      {renderProgList()}
      {ColorModeIcon()}
    </>
  );
};

export default ProgramOverview;
